import { render, staticRenderFns } from "./IconExternalLinkOutline.vue?vue&type=template&id=3aeb6ed2"
import script from "./IconExternalLinkOutline.vue?vue&type=script&lang=js"
export * from "./IconExternalLinkOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports